module.exports = __webpack_public_path__ + "static/media/add_to_QR_icon.d45e9148.svg";